import { useEffect, useState } from "react";
import * as configUtils from "util/config";

export const useDDJJEnabledOptions = () => {
    const [enabledOptions, setEnabledOptions] = useState({});

    useEffect(() => {
        setEnabledOptions({
            v1: configUtils.getBoolean("comex.ddjj.general.v1.enabled"),
            v2: configUtils.getBoolean("comex.ddjj.general.v2.enabled"),
            v3: configUtils.getBoolean("comex.ddjj.general.v3.enabled"),
            v4: configUtils.getBoolean("comex.ddjj.general.v4.enabled"),
            v5: configUtils.getBoolean("comex.ddjj.general.v5.enabled"),
            v6: configUtils.getBoolean("comex.ddjj.general.v6.enabled"),
            v7: configUtils.getBoolean("comex.ddjj.general.v7.enabled"),
            v8: configUtils.getBoolean("comex.ddjj.general.v8.enabled"),
            v9: configUtils.getBoolean("comex.ddjj.general.v9.enabled"),
            v10: configUtils.getBoolean("comex.ddjj.general.v10.enabled"),
            v11: configUtils.getBoolean("comex.ddjj.general.v11.enabled"),
            v12: configUtils.getBoolean("comex.ddjj.general.v12.enabled"),
            v13: configUtils.getBoolean("comex.ddjj.general.v13.enabled"),
            v14: configUtils.getBoolean("comex.ddjj.general.v14.enabled"),
            v15: configUtils.getBoolean("comex.ddjj.general.v15.enabled"),
            v16: configUtils.getBoolean("comex.ddjj.general.v16.enabled"),
            v17: configUtils.getBoolean("comex.ddjj.general.v17.enabled"),
            v18: configUtils.getBoolean("comex.ddjj.general.v18.enabled"),
            v19: configUtils.getBoolean("comex.ddjj.general.v19.enabled"),
            v20: configUtils.getBoolean("comex.ddjj.general.v20.enabled"),
            v21: configUtils.getBoolean("comex.ddjj.general.v21.enabled"),
        });
    }, []);

    return { enabledOptions };
};

export default useDDJJEnabledOptions;
